module.exports = __webpack_public_path__ + "static/media/apple-app.c9a5023b.svg";